/* Invoice Service – CRUD operations for invoices and their details */

import api from '@/api/api'
import notify from '@/utils/notify'
import router from '@/router'

export default {
  async getInvoices(storeId) {
    const data = {
      method: 'get',
      url: storeId ? `invoices/${storeId}` : 'invoices'
    }
    
    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },
  
  async createInvoice(json) {
    const data = {
      method: 'post',
      url: 'invoice',
      body: json
    }
    
    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Invoice created successfully')
      await router.push(`/invoice/${response.data.id}`)
      return true
    }
    return false
  },
  
  async getInvoice(id) {
    const data = {
      method: 'get',
      url: 'invoice/' + id
    }
    
    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return null
  },
  
  async updateInvoice(json, id) {
    const data = {
      method: 'put',
      url: 'invoice/' + id,
      body: json
    }
    
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Invoice updated successfully')
      await router.push(`/invoice/${id}`)
      return true
    }
    return false
  },
  
  async deleteInvoice(id) {
    const data = {
      method: 'delete',
      url: 'invoice/' + id
    }
    
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Invoice deleted successfully')
      return true
    }
    return false
  },
  
  async getInvoiceDetails(invoiceId, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `invoice/${invoiceId}/details${query.toString() ? `?${query.toString()}` : ''}`
    }
    
    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return {data: [], total: 0}
  },
  
  async createInvoiceDetails(json) {
    const data = {
      method: 'post',
      url: 'invoice-details',
      body: json
    }
    
    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Invoice item added successfully')
      return true
    }
    return false
  },
  
  async updateInvoiceDetails(json, id) {
    const data = {
      method: 'put',
      url: 'invoice-details/' + id,
      body: json
    }
    
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Invoice item updated successfully')
      return true
    }
    return false
  },
  
  async deleteInvoiceDetails(id) {
    const data = {
      method: 'delete',
      url: 'invoice-details/' + id
    }
    
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Invoice item deleted successfully')
      return true
    }
    return false
  },
  
  async completeInvoice(id) {
    const data = {
      method: 'post',
      url: `invoice/${id}/complete`
    }
    
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Invoice completed successfully')
      return true
    }
    return false
  }
}
